import { render, staticRenderFns } from "./PollsQuestions.vue?vue&type=template&id=2cd72ff2&"
import script from "./PollsQuestions.vue?vue&type=script&lang=js&"
export * from "./PollsQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports